import { useCallback, useState } from "react";

// Remembers whether a panel is collapsed, per browser. Storage can be
// unavailable (private window, blocked site data), so it never throws and the
// panel just starts expanded.
export const useCollapsed = (key, defaultCollapsed = false) => {
  const storageKey = `collapsed:${key}`;
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return saved === null ? defaultCollapsed : saved === "1";
    } catch {
      return defaultCollapsed;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(storageKey, next ? "1" : "0");
      } catch {
        /* not persisted, still toggles */
      }
      return next;
    });
  }, [storageKey]);

  return { collapsed, toggle };
};
